<template>
	<div ref="mainHeader" class="header-wrap" :class="{'fixed-header':IsFixedHeader()}">
		<b-navbar toggleable="lg" type="light" variant="light"
			style="border-bottom: 1px solid #ebebeb;margin-top: 10px; background-color: transparent !important;">
			<b-navbar-brand href="#">
				<img src="../assets/logo_new.png" height="45px" width="145px" class="d-inline-block align-top" alt="缤纷种苗">
			</b-navbar-brand>
			<b-navbar-nav>
				<b-nav-item :to="{ name: 'Home' }" :active="getActiveStatus(['Home'])">首页</b-nav-item>
				<b-nav-item :to="{ name: 'ProductList' }" :active="getActiveStatus(['ProductList'])">产品</b-nav-item>
				<!-- <b-nav-item :to="{ name: 'SalesList' }"
                    :active="getActiveStatus(['SalesList'])">现售</b-nav-item>
                <b-nav-item :to="{ name: 'FastBooking' }"
                    :active="getActiveStatus(['BookingList','FastBooking'])">预售</b-nav-item> -->
				<!-- <b-nav-item v-if="checkMemberLogin()" :to="{ name: 'CartList'}" :active="getActiveStatus(['CartList'])">
					购物车</b-nav-item> -->
				<b-nav-item v-if="checkMemberLogin()" :to="{ name: 'Cart'}" :active="getActiveStatus(['Cart'])">
					购物车</b-nav-item>
				<!-- <b-nav-item v-if="checkMemberLogin()" :to="{ name: 'OrderList'}"
					:active="getActiveStatus(['OrderList'])">定单列表</b-nav-item> -->
				<b-nav-item v-if="checkMemberLogin()" :to="{ name: 'IntentionList'}"
					:active="getActiveStatus(['IntentionList'])">意向单</b-nav-item>
				<b-nav-item v-if="checkMemberLogin()" :to="{ name: 'NoDepositList'}"
					:active="getActiveStatus(['NoDepositList'])">待支付定单</b-nav-item>
					<b-nav-item v-if="checkMemberLogin()" :to="{ name: 'DepositList'}"
					:active="getActiveStatus(['DepositList'])">定金单</b-nav-item>
				<b-nav-item v-if="checkMemberLogin()" :to="{ name: 'DeliveryList'}"
					:active="getActiveStatus(['DeliveryList'])">发货单</b-nav-item>
				<b-nav-item :to="{ name: 'AboutUs'}" :active="getActiveStatus(['AboutUs'])">关于我们</b-nav-item>
				<b-nav-item :to="{ name: 'ContactUs'}" :active="getActiveStatus(['ContactUs'])">联系我们</b-nav-item>
				<!-- <b-nav-item v-if="checkMemberLogin()"
                    :to="{ name: 'FavList'}"
                    :active="getActiveStatus(['FavList'])">收藏列表</b-nav-item> -->
				<!-- <b-nav-item v-if="checkMemberLogin()"
					:to="{ name: 'RefundList'}"
					:active="getActiveStatus(['RefundList'])">余额提现</b-nav-item> -->

				<!-- <b-nav-item-dropdown text="关于我们">
                    <b-dropdown-item :to="{ name: 'AboutUs' }">缤纷简介</b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'ContactUs' }">联系我们</b-dropdown-item>
                </b-nav-item-dropdown> -->

			
			</b-navbar-nav>
			
			
			<b-navbar-nav class="ml-auto">
				<!-- <b-nav-form>
                    <b-form-input v-model="searchValue"
                        size="sm"
                        class="mr-sm-2"
                        placeholder="输入品名或编码"></b-form-input>
                    <b-button size="sm"
                        class="my-2 my-sm-0"
                        v-on:click="searchProduct()">搜索</b-button>
                </b-nav-form> -->

				<b-nav-item-dropdown right class="dropdown-wrap">
					<template slot="button-content">{{memberInfo.memberName||'游客'}}</template>
					<b-dropdown-item v-if="!checkMemberLogin() " :to="{ name: 'MemberLogin' }">登录</b-dropdown-item>
					<!-- <b-dropdown-text variant="danger" v-if="checkMemberLogin()">
						<div>账户余额:￥{{numberToFixed(memberInfo.memberFund,2)}}</div>
						<div>可用余额:￥{{numberToFixed(memberInfo.memberFund-memberInfo.depositBablance,2)}}</div>
					</b-dropdown-text> -->

					<!-- <b-dropdown-item variant="danger"
                        v-if="checkMemberLogin()"
                        :to="{ name: 'Pay' }">在线充值</b-dropdown-item> -->
					<b-dropdown-divider v-if="checkMemberLogin()"></b-dropdown-divider>
					<b-dropdown-item v-if="checkMemberLogin()" :to="{ name: 'PersonInfo' }">个人信息</b-dropdown-item>
					<b-dropdown-item v-if="checkMemberLogin()" v-on:click="logout()">登出</b-dropdown-item>
				</b-nav-item-dropdown>
			</b-navbar-nav>
		</b-navbar>
		<b-navbar-nav v-if="config.devEnvironment">
				<b-nav-item ><span
						style="color:red;font-size:18px;margin-right:50px;font-weight:bold;">这是测试环境，请勿在此入真实业务数据！！！！！！！</span>
				</b-nav-item>
			</b-navbar-nav>
	</div>
	
</template>

<script>
	// import utils from '@/libs/utils';
	import api from "@/api/api";
	import {
		numberToFixed
	} from "@/libs/utils";
	import "@/style/global.css";
	import config from '@/config';
	import { clearUserInfo } from '@/utils/localStorage';
	export default {
		name: 'Header',
		data() {
			return {
				config,
				showLogin: true,
				searchValue: '',
				memberInfo: {
					memberName: '',
					memberFund: 0
				}
			};
		},
		computed: {
			getActiveStatus() {
				return function(routeNames) {
					return routeNames.includes(this.$route.name);
				};
			}
		},
		mounted() {
			if (this.$route.name === 'PayWeiXin') {
				this.$refs.mainHeader.style.display = "none";
			} else {
				if (this.checkMemberLogin()) {
					this.getMemberInfo();
				}
			}
		},
		methods: {
			numberToFixed,
			getMemberInfo() {
				api.webGetMemberUserDetail({
					userUuid: this.getLoginCookieUuid()
				}).then(res => {
					if (res.code === 0) {
						this.memberInfo = res.data;
						
					}
				});
			},
			logout() {
				this.clearLoginCookies();
				clearUserInfo();
				window.parent.window.location.reload();
			},
			searchProduct() {
				this.$router.push({
					path: '/product/product-search',
					query: {
						searchValue: this.searchValue
					}
				});
			},
			IsFixedHeader () {
				if(this.$route.name==='MemberLogin'||this.$route.name==='MemberRegister')
				{
					return false;
				}
				return true;
			},
		},
	};
</script>

<style>
	.navbar-light .navbar-nav .active>.nav-link,
	.navbar-light .navbar-nav .nav-link.active,
	.navbar-light .navbar-nav .nav-link.show,
	.navbar-light .navbar-nav .show>.nav-link {
		color: #00b151 !important;
		font-weight: 600
			/* font-size: 20px; */
			/* font-style: italic; */
	}

	.header-wrap .bg-light {
		background-color: transparent !important;
	}

	.navbar,
	.navbar-light,
	.bg-light,
	.navbar-expand-lg,
	.bg-light {
		background-color: transparent !important;
	}

	.navbar-expand-lg .navbar-nav .dropdown-menu {
		width: 240px;
	}

	.custom-control-label {
		margin-top: 0;
	}

	/* 个人中心 */
	.navbar-expand-lg .navbar-nav .dropdown-menu {
		width: 200px;
	}

	.dropdown-wrap .dropdown-item.active,
	.dropdown-wrap .dropdown-item:active {
		color: #fff;
		text-decoration: none;
		background-color: #00b151;
	}

	.dropdown-wrap .dropdown-item:focus,
	.dropdown-wrap .dropdown-item:hover {
		color: #fff;
		text-decoration: none;
		background-color: #00b151;
	}
	.fixed-header {
		position: sticky;
		top: 0;
		height: auto;
		z-index: 1030; 
		background-color: #fff  !important;; 
		}
</style>



// WEBPACK FOOTER //
// src/view/header.vue